export default __webpack_public_path__ + "static/about-us-3-da96d26b6772d1d81720d9fd117908d3.png";